import { getUserCurrentStore, getAuthToken } from 'utils/auth';

import { DownloadTemplateOptions } from 'components/MenuMakeImport/types';

export const API_BASE_URL = `${process.env.REACT_APP_BASE_URL_API}/api`;

interface UploadFileOptions {
  body: FormData;
}

export async function uploadFile(options: UploadFileOptions) {
  const storeUuid = getUserCurrentStore()?.uuid;
  const headers = {
    Authorization: `Bearer ${getAuthToken()?.accessToken}`,
  };

  const res = await fetch(`${API_BASE_URL}/v1/menu-maker/menu-template/validation/?store_uuid=${storeUuid}`, {
    method: 'POST',
    ...options,
    headers,
  });
  const data = await res.json();
  if (!res.ok || data.ok === false) {
    throw data.data;
  }
  return data;
}

interface CreateMenuOptions {
  body: FormData;
}

export async function createMenu(options: CreateMenuOptions) {
  const storeUuid = getUserCurrentStore()?.uuid;
  const headers = {
    Authorization: `Bearer ${getAuthToken()?.accessToken}`,
  };

  const res = await fetch(`${API_BASE_URL}/v1/menu-maker/menu-template/creation/?store_uuid=${storeUuid}`, {
    method: 'POST',
    ...options,
    headers,
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error('Error creating menu');
  }
  return data;
}

export async function downloadTemplate(options: DownloadTemplateOptions) {
  const storeUuid = getUserCurrentStore()?.uuid;
  const headers = {
    Authorization: `Bearer ${getAuthToken()?.accessToken}`,
  };

  const res = await fetch(
    `${API_BASE_URL}/v1/menu-maker/menu-template/download/?store_uuid=${storeUuid}&type=${options.type}`,
    {
      method: 'GET',
      headers,
    },
  );
  const data = await res.blob();
  if (!res.ok) {
    throw new Error('Error downloading template');
  }
  return data;
}

export async function getExistsMenu() {
  const storeUuid = getUserCurrentStore()?.uuid;
  const headers = {
    Authorization: `Bearer ${getAuthToken()?.accessToken}`,
  };
  const res = await fetch(`${API_BASE_URL}/v1/menu-maker/menu-template/exists/?store_uuid=${storeUuid}`, {
    method: 'GET',
    headers,
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error('Error getting exists menu');
  }
  return data;
}
